export enum AiDesignGraphicTileSize {
  SMALL = 's',
  MEDIUM = 'm',
  LARGE = 'l',
}
